<div
  class="cart-confirmation flex--column flex--nowrap flex__child--auto overflow-auto"
  *ngIf="cart$ | async as cart; else noCart"
  [ngClass]="{
    'body-style': (isAtLeastAdvisor$ | async) === true,
    'body-style-client': (isAtLeastAdvisor$ | async) !== true,
  }"
>
  <div class="cart-confirmation wrapper--spacing-horizontal flex__child--auto" [class.margin-agreement]="isNotDesktopView$ | async">
    <h1 class="text--h1">{{ 'cart-confirmation.check-order' | translate }}</h1>
    <div class="spacing--margin-vertical" *ngIf="(location$ | async) && (customer$ | async)">
      <agr-location-summary [location]="location$ | async" [customer]="customer$ | async"></agr-location-summary>
    </div>

    <mat-divider class="cart-confirmation__divider"></mat-divider>

    <div class="spacing--margin-top">
      <agr-notification-status-message></agr-notification-status-message>
    </div>
    <div class="spacing--margin-vertical">
      <app-cart [cart]="cart" [editable]="false" [showPrice]="true" cartScreenType="confirmation"></app-cart>
    </div>

    <div class="flex--row">
      <div class="spacing--margin-vertical spacing--padding-right">
        <div class="text--small text--gray spacing--padding-top" *ngIf="cart?.orderMetadata?.weightInformation || cart?.status === cartLifeCycle.simulating">
          {{ 'cart-confirmation.total-order-weight' | translate }}
        </div>
        <div class="text--large" *ngIf="cart?.orderMetadata?.weightInformation" data-test="confirmation__weight-information">
          {{ cart?.orderMetadata.weightInformation.weight | agrNumber }}
          {{ 'unit.' + cart?.orderMetadata.weightInformation.unit | translate }}
        </div>
        <div class="spinner-container" *ngIf="!cart?.orderMetadata?.weightInformation && cart?.status === cartLifeCycle.simulating">
          <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
          <span class="spinner-text blink-soft">{{ 'cart-confirmation.weight-spinnerText' | translate }}</span>
        </div>
      </div>

      <div class="spacing--margin-vertical spacing--padding-right">
        <app-total-ordered-weight [cart]="cart$ | async"></app-total-ordered-weight>
      </div>

      <div *ngIf="shouldShowPrice$ | async" class="spacing--margin-vertical">
        <ng-container *ngIf="!isPresalesOrder(cart.type)">
          <app-total-price [cart]="cart$ | async" />
        </ng-container>
        <ng-container *ngIf="isPresalesOrder(cart.type)">
          <app-total-price-per-period [cart]="cart$ | async" />
        </ng-container>
      </div>
    </div>

    <div *ngIf="validationMessages$ | async as validationFeedback">
      <div
        *ngFor="let feedback of validationFeedback"
        class="cart-confirmation__error notification text--input-small flex--row spacing--margin-bottom"
        [class]="'notification-' + ((feedback.severityLevel | lowercase) || 'error')"
      >
        <mat-icon class="flex--align-self-center">
          {{ (feedback.severityLevel | lowercase) || 'error' }}
        </mat-icon>
        <div>{{ feedback.message }}</div>
      </div>
    </div>
  </div>

  <div class="footer-style footer-width">
    <div [class.navigation-rail]="(isNavigationRailOpened$ | async) === true">
      <div
        [ngClass]="{
          'side-bar': (isSideNavCollapsed$ | async) === false && (isSideNavOpen$ | async) === true,
        }"
      >
        <div
          class="layout--padding-horizontal spacing--padding-vertical background-color--white border-top--gray4"
          *ngIf="(isNotDesktopView$ | async) === true && (isAtLeastAdvisor$ | async) !== true"
        >
          <app-cart-agreement [location]="location$ | async"></app-cart-agreement>
        </div>
        <div
          class="layout--padding-horizontal spacing--padding-vertical flex--justify-space-between flex--align-center background-color--white border-top--gray4"
        >
          <div>
            <button
              mat-button
              data-test="confirmation__change_order"
              color="primary"
              (click)="editOrder()"
              class="cart-confirmation__change-order changeorder_btn"
            >
              <mat-icon>arrow_back</mat-icon>
              {{ 'cart-confirmation.change-order' | translate }}
            </button>
          </div>

          <div class="flex--align-center">
            <div class="checkbox-with-error" *ngIf="(isNotDesktopView$ | async) !== true && (isAtLeastAdvisor$ | async) !== true">
              <app-cart-agreement [location]="location$ | async"></app-cart-agreement>
            </div>

            <div class="footer-order-buttons">
              <button
                class="button--spacing"
                mat-flat-button
                data-test="confirmation__instant-order"
                color="accent"
                matTooltip="{{ 'cart-confirmation.instant-order-tooltip' | translate }}"
                (click)="markOrderAsInstantOrder()"
                *ngIf="(isAtLeastAdvisor$ | async) && (isSimulating$ | async) && (hasValidationMessages$ | async) === false && env.INSTANT_ORDER"
              >
                <mat-icon>arrow_forward</mat-icon>
                {{ 'cart-confirmation.instant-order' | translate }}
              </button>

              <button
                class="button--spacing"
                mat-flat-button
                data-test="confirmation__finalize-order"
                color="primary"
                *ngIf="isSimulationCompleted$ | async"
                (click)="finalizeOrder()"
              >
                <mat-icon>shopping_cart</mat-icon>
                {{ (isReturnOrder$ | async) ? ('cart-confirmation.returnOrder' | translate) : ('cart-confirmation.order' | translate) }}
              </button>

              <button
                class="button--spacing"
                mat-flat-button
                data-test="confirmation__simulating"
                color="primary"
                *ngIf="cart?.status === cartLifeCycle.simulating"
                [disabled]="true"
              >
                <div class="flex--row flex--nowrap flex--align-center">
                  <mat-spinner diameter="21" class="spacing--margin-right"></mat-spinner>
                  <span class="flex--wrap">{{ 'cart-confirmation.simulating' | translate }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noCart>
  <agr-notification-empty
    [isEmpty]="true"
    [emptyTitle]="'cart-confirmation.empty-title' | translate"
    [emptyDescription]="'cart-confirmation.empty-description' | translate"
    emptyActionColor="primary"
    [emptyActionText]="'cart-confirmation.continue-shopping' | translate"
    [showEmptyAction]="true"
    emptyActionIcon="shopping_cart"
    (emptyAction)="navigateToOverview()"
  >
  </agr-notification-empty>
</ng-template>
